import React from "react";

const NoDataIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="234"
    height="103"
    viewBox="0 0 234 103"
    fill="none"
  >
    <g filter="url(#filter0_dd_2840_83767)">
      <g clip-path="url(#clip0_2840_83767)">
        <rect
          x="3"
          y="2"
          width="156"
          height="96.9429"
          rx="8.91429"
          fill="white"
        />
        <rect
          x="108.857"
          y="6.45642"
          width="43.4571"
          height="8.91429"
          rx="2.22857"
          fill="#060216"
          fill-opacity="0.08"
        />
        <g clip-path="url(#clip1_2840_83767)">
          <path
            d="M150.364 13.4222L149.155 12.2132"
            stroke="#060216"
            stroke-opacity="0.24"
            stroke-width="0.557143"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.579 12.8639C148.81 12.8639 149.808 11.8662 149.808 10.6354C149.808 9.40456 148.81 8.4068 147.579 8.4068C146.348 8.4068 145.351 9.40456 145.351 10.6354C145.351 11.8662 146.348 12.8639 147.579 12.8639Z"
            stroke="#060216"
            stroke-opacity="0.24"
            stroke-width="0.557143"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <mask id="path-6-inside-1_2840_83767" fill="white">
          <path d="M3 1.99927H31.9714V98.9421H3V1.99927Z" />
        </mask>
        <path d="M3 1.99927H31.9714V98.9421H3V1.99927Z" fill="#FAFAFA" />
        <path
          d="M31.9714 1.99927H30.8571V98.9421H31.9714H33.0857V1.99927H31.9714Z"
          fill="#F1F5F9"
          mask="url(#path-6-inside-1_2840_83767)"
        />
        <rect
          x="7.45703"
          y="19.8278"
          width="17.8286"
          height="4.45714"
          rx="2.22857"
          fill="#060216"
          fill-opacity="0.08"
        />
        <rect
          x="7.45703"
          y="25.3993"
          width="17.8286"
          height="4.45714"
          rx="2.22857"
          fill="#060216"
          fill-opacity="0.08"
        />
        <rect
          x="7.45703"
          y="30.9707"
          width="17.8286"
          height="4.45714"
          rx="2.22857"
          fill="#060216"
          fill-opacity="0.08"
        />
        <rect
          x="7.45703"
          y="6.45642"
          width="8.91429"
          height="8.91429"
          rx="2.22857"
          fill="#060216"
          fill-opacity="0.08"
        />
      </g>
      <rect
        x="3.55714"
        y="2.55714"
        width="154.886"
        height="95.8286"
        rx="8.35714"
        stroke="#F1F5F9"
        stroke-width="1.11429"
      />
    </g>
    <g filter="url(#filter1_d_2840_83767)">
      <rect
        x="41"
        y="24.9707"
        width="183"
        height="26"
        rx="8"
        fill="white"
        shape-rendering="crispEdges"
      />
      <rect
        x="41.5"
        y="25.4707"
        width="182"
        height="25"
        rx="7.5"
        stroke="#F1F5F9"
        shape-rendering="crispEdges"
      />
      <rect
        x="49"
        y="32.9707"
        width="63"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
      <rect
        x="122"
        y="32.9707"
        width="42"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
      <rect
        x="174"
        y="32.9707"
        width="42"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
    </g>
    <g filter="url(#filter2_d_2840_83767)">
      <rect
        x="51"
        y="57.9707"
        width="183"
        height="26"
        rx="8"
        fill="white"
        shape-rendering="crispEdges"
      />
      <rect
        x="51.5"
        y="58.4707"
        width="182"
        height="25"
        rx="7.5"
        stroke="#F1F5F9"
        shape-rendering="crispEdges"
      />
      <rect
        x="59"
        y="65.9707"
        width="63"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
      <rect
        x="132"
        y="65.9707"
        width="42"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
      <rect
        x="184"
        y="65.9707"
        width="42"
        height="10"
        rx="5"
        fill="#060216"
        fill-opacity="0.08"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_2840_83767"
        x="0"
        y="0"
        width="162"
        height="102.943"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_2840_83767"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2840_83767"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2840_83767"
          result="effect2_dropShadow_2840_83767"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2840_83767"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2840_83767"
        x="41"
        y="24.9707"
        width="183"
        height="27"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2840_83767"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2840_83767"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2840_83767"
        x="51"
        y="57.9707"
        width="183"
        height="27"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2840_83767"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2840_83767"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_2840_83767">
        <rect
          x="3"
          y="2"
          width="156"
          height="96.9429"
          rx="8.91429"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_2840_83767">
        <rect
          width="6.68571"
          height="6.68571"
          fill="white"
          transform="translate(144.515 7.57068)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default NoDataIcon;
